import _ from "lodash"

/** 超级管理员权限码，后端约定固定字符串，命中即不受权限码限制（AD-04） */
const SUPER_ADMIN_PERM = "*:*:*"

/**
 * 根据用户权限码过滤路由。route.meta.permissions 存的是后端权限码（如
 * "system:tenant:list"），跟当前用户 GET /getInfo 返回的 permissions 数组比对——
 * 不再是角色标识比对（此前是跟 roleKey 数组比对，字段名 permissions 容易引起误解，
 * 权限码粒度更细也跟后端 @PreAuthorize 校验口径一致，改成这个更准确）。
 * @param routes - 待过滤路由
 * @param permissions - 当前用户的权限码数组（GET /getInfo 的 permissions 字段）
 */
export function filterAuthRoutesByUserPermission(
    routes: AuthRoute.Route[],
    permissions: string[]
) {
    return routes
        .map((route) => filterAuthRouteByUserPermission(route, permissions))
        .flat(1)
}

/**
 * 根据用户权限码过滤单个路由
 * @param route - 单个路由
 * @param permissions - 当前用户的权限码数组
 */
function filterAuthRouteByUserPermission(
    route: AuthRoute.Route,
    permissions: string[]
): AuthRoute.Route[] {
    const filterRoute = { ...route }
    const isSuperAdmin = permissions.includes(SUPER_ADMIN_PERM)
    const hasPermission =
        isSuperAdmin ||
        !route.meta.permissions ||
        _.intersection(route.meta.permissions, permissions).length > 0

    if (!hasPermission) return []

    if (filterRoute.children && filterRoute.children.length > 0) {
        const filterChildren = filterRoute.children
            .map((item) => filterAuthRouteByUserPermission(item, permissions))
            .flat(1)
        // 目录本身没配 permissions（比如"系统管理”，靠子节点各自的权限码控制）时，
        // 上面 hasPermission 会恒为 true；如果子节点全部被过滤掉，不能留一个点开
        // 是空白页的空壳目录，这里必须连父级一起隐藏。
        if (filterChildren.length === 0) return []
        Object.assign(filterRoute, { children: filterChildren })
    }
    return [filterRoute]
}
